var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2260_2180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4062 0.625H12.8438C12.2406 0.625 11.75 1.11563 11.75 1.71875V8.90625C11.75 9.50937 12.2406 10 12.8438 10H14.4062C15.0094 10 15.5 9.50937 15.5 8.90625V1.71875C15.5 1.11563 15.0094 0.625 14.4062 0.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6993 0.46875C2.48055 0.46875 1.44305 1.34375 1.2368 2.54375L0.536804 6.60625C0.274304 8.1375 1.4493 9.53125 2.9993 9.53125H5.9493C5.9493 9.53125 5.48055 10.4688 5.48055 12.0312C5.48055 13.9062 6.8868 14.5312 7.5118 14.5312C8.1368 14.5312 8.4493 14.2188 8.4493 12.6562C8.4493 11.1713 9.88743 9.97625 10.8124 9.36063V1.61812C9.8118 1.155 7.80868 0.46875 4.6993 0.46875H3.6993Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2260_2180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailDone);
export default __webpack_public_path__ + "static/media/fail-done.4d3e23c2cd3d6f40a1e5778048598710.svg";
export { ForwardRef as ReactComponent };